<template>

    <master-panel
            @edit:client="onClientEdit"
            @appointment:cancel="onAppointmentCancel"
            @attention:start="onAttentionStart"
            @attention:end="onAttentionEnd"
            @change:events="onEventsChange"
    >

        <template v-slot:summary="data">
            <attention-summary v-if="eventDetails" :event="eventDetails" style="border-radius: 10px" class="mt-2 text-left"/>
        </template>

        <template v-slot:body="data">
            <div v-if="eventDetails">

              <template v-if="eventDetails.derived_from_event">
                <v-slide-y-transition>
                  <div v-show="hasAccessToDerivation">
                    <client-history-title
                        class="mt-4"
                        title="Preparación:"
                        icon="fas fa-file-medical" />

                    <derivation class="mt-2" @change="onDerivationUpdated" :derivation-event="eventDetails.derived_from_event" />
                  </div>
                </v-slide-y-transition>
              </template>

                <client-history-title
                        class="mt-4"
                        title="Historia Clínica:"
                        icon="fas fa-file-medical-alt" />

                <client-history style="border-radius: 10px" class="mt-2"
                                :default-history="eventDetails.medical_history_items"
                                :allow-add="eventDetails.event_status.id === 4"
                                :client-id="eventDetails.client.id"
                                :event-id="eventDetails.id"
                                @detach="onHistoryItemDetach"
                                @attach="onHistoryItemAttach"
                />

                <client-history-title
                        class="mt-4"
                        title="Enfermedad Actual:"
                        icon="fas fa-notes-medical" />

                <client-anamnesis
                        class="mt-2"
                        style="border-radius:10px"
                        @attach:option="onOptionAttach"
                        @detach:option="onOptionDetach"
                        @attach:symptom="onSymptomAttach"
                        @detach:symptom="onSymptomDetach"
                        @update:comment="onCommentUpdate"
                        :eventId="eventDetails.id"
                        :readonly="eventDetails.anamnesis ? eventDetails.event_status_id !== 4 : false"
                        :anamnesis="eventDetails && eventDetails.anamnesis || null" />

                <client-history-title
                        class="mt-4"
                        title="Diagnóstico:"
                        icon="fas fa-diagnoses" />

                <client-diagnoses
                        :client-diagnoses="eventDetails.diagnoses"
                        :event-id="eventDetails.id"
                        :readonly="eventDetails.event_status_id !== 4"
                        @attach="onDiagnosisAttach"
                        @detach="onDiagnosisDetach"
                        class="mt-2"
                        style="border-radius:10px"/>

                <client-history-title
                        class="mt-4"
                        title="Indicaciones:"
                        icon="fas fa-chalkboard-teacher" />

                <client-indications
                        :event-id="eventDetails.id"
                        :indication="eventDetails.indication || null"
                        :readonly="eventDetails.event_status_id !== 4"
                        @attach:medicine="onMedicineAttach"
                        @detach:medicine="onMedicineDetach"
                        @attach:exam="onComplementaryExamAttach"
                        @detach:exam="onComplementaryExamDetach"
                        class="mt-2"
                        style="border-radius:10px"
                        @update:glasses="onGlassesUpdate"
                        @update:control="onControlUpdate"

                />

              <client-history-title
                  title="Pasos a Seguir:"
                  class="mt-4"
                  icon="fas fa-list-ol" />

              <steps-to-follow @change="onStepsToFollowChange" class="mt-2" :event-id="eventDetails.id" :steps="eventDetails.steps" />

            </div>
        </template>


    </master-panel>

</template>

<script>


import MasterPanel from './MasterPanel'
import AttentionScreenMixin from '@/mixins/AttentionScreenMixin'
import {getPhysicalExamName} from "@/utils/Strings";

import ClientAnamnesis from "../ClientAnamnesis.vue";
import ClientHistory from '../ClientHistory'
import ClientDiagnoses from '../ClientDiagnoses'
import ClientIndications from '../ClientIndications'
import AttentionSummary from '../AttentionSummary'
import Derivation from "../Derivation";
import StepsToFollow from "../StepsToFollow";

    export default{
        components: {
          StepsToFollow,
          Derivation,
            MasterPanel,
            ClientHistory,
            ClientAnamnesis,
            ClientDiagnoses,
            ClientIndications,
            AttentionSummary
        },
        mixins: [AttentionScreenMixin],
        data(){
            return {}
        },
        methods: {
            onControlUpdate(control){
                var vm = this
                if(!vm.eventDetails) return
                if(!vm.eventDetails.indication){
                    vm.eventDetails.indication = {
                        control: control
                    }
                    return
                }
                vm.eventDetails.indication.control = control
            },
            onGlassesUpdate(glasses){
                var vm = this
                if(!vm.eventDetails) return

                if(!vm.eventDetails.indication){
                    vm.eventDetails.indication = {
                        glasses: glasses
                    }
                    return
                }

                vm.eventDetails.indication.glasses = glasses
            },
            onHistoryItemDetach(historyItem){

                var vm = this
                if(vm.eventDetails){

                    const categoryIndex = vm.eventDetails
                            .medical_history_items
                            .findIndex(cat => cat.id === historyItem.medical_history_category_id)

                    if(categoryIndex === -1) return

                    const foundIndex = vm.eventDetails
                            .medical_history_items[categoryIndex]
                            .items
                            .findIndex(item => item.id === historyItem.id)

                    if(foundIndex !== -1){
                        vm.eventDetails.medical_history_items[categoryIndex].items.splice(foundIndex, 1)
                    }


                }

            },
            onHistoryItemAttach(historyItem){

                var vm = this
                if(vm.eventDetails){

                    const categoryIndex = vm.eventDetails
                            .medical_history_items
                            .findIndex(cat => cat.id === historyItem.medical_history_category_id)

                    if(categoryIndex === -1) return

                    const foundIndex = vm.eventDetails
                            .medical_history_items[categoryIndex]
                            .items
                            .findIndex(ex => ex.id === historyItem.id)

                    if(foundIndex !== -1){
                        vm.eventDetails.medical_history_items[categoryIndex].items.splice(foundIndex, 1, historyItem)
                    }else{
                        vm.eventDetails.medical_history_items[categoryIndex].items.push(historyItem)
                    }

                }
            },
            onDiagnosisDetach(diagnosis){
                var vm = this
                if(vm.eventDetails){
                    const foundIndex = vm.eventDetails.diagnoses.findIndex(item => item.id === diagnosis.id)
                    if(foundIndex !== -1){
                        vm.eventDetails.diagnoses.splice(foundIndex, 1)
                    }
                }
            },
            onDiagnosisAttach(diagnosis){
                var vm = this
                if(vm.eventDetails){

                    const foundIndex = vm.eventDetails
                            .diagnoses.findIndex(item => item.id === diagnosis.id)

                    if(foundIndex !== -1){
                        vm.eventDetails.diagnoses.splice(foundIndex, 1, diagnosis)
                    }else{
                        vm.eventDetails.diagnoses.push(diagnosis)
                    }

                }
            },
            onMedicineAttach(medicine){
                var vm = this
                if(vm.eventDetails){

                    if(!vm.eventDetails.indication){
                        vm.eventDetails.indication = {
                            medicines: []
                        }
                    }

                    if(!vm.eventDetails.indication.medicines){
                        vm.eventDetails.indication.medicines = []
                    }

                    const foundIndex = vm.eventDetails
                            .indication
                            .medicines
                            .findIndex(ex => ex.id === medicine.id)

                    if(foundIndex !== -1){
                        vm.eventDetails
                                .indication
                                .medicines
                                .splice(foundIndex, 1, medicine)
                    }else{
                        vm.eventDetails
                                .indication
                                .medicines
                                .push(medicine)
                    }

                }
            },
            onComplementaryExamAttach(exam){
                var vm = this
                if(vm.eventDetails){

                    if(!vm.eventDetails.indication){
                        vm.eventDetails.indication = {
                            complementary_exams: []
                        }
                    }

                    if(!vm.eventDetails.indication.complementary_exams){
                        vm.eventDetails.indication.complementary_exams = []
                    }

                    const foundIndex = vm.eventDetails
                            .indication
                            .complementary_exams
                            .findIndex(ex => ex.id === exam.id)

                    if(foundIndex !== -1){
                        vm.eventDetails
                                .indication
                                .complementary_exams
                                .splice(foundIndex, 1, exam)
                    }else{
                        vm.eventDetails
                                .indication
                                .complementary_exams
                                .push(exam)
                    }

                }
            },
            onMedicineDetach(medicine){
                var vm = this
                if(vm.eventDetails){
                    const foundIndex = vm.eventDetails.indication.medicines.findIndex(item => item.id === medicine.id)
                    if(foundIndex !== -1){
                        vm.eventDetails.indication.medicines.splice(foundIndex, 1)
                    }
                }
            },
            onComplementaryExamDetach(exam){
                var vm = this
                if(vm.eventDetails){
                    const foundIndex = vm.eventDetails.indication.complementary_exams.findIndex(item => item.id === exam.id)
                    if(foundIndex !== -1){
                        vm.eventDetails.indication.complementary_exams.splice(foundIndex, 1)
                    }
                }
            },
            onExamDetach(exam){
                var vm = this
                if(vm.eventDetails){
                    const foundIndex = vm.eventDetails.physical_exams.findIndex(item => item.id === exam.id)
                    if(foundIndex !== -1){
                        vm.eventDetails.physical_exams.splice(foundIndex, 1)
                    }
                }
            },
            onExamUpdate(exam){
                var vm = this
                if(vm.eventDetails){
                    const foundIndex = vm.eventDetails.physical_exams.findIndex(item => item.id === exam.id)
                    if(foundIndex !== -1){
                        vm.eventDetails.physical_exams.splice(foundIndex, 1, exam)
                    }
                }
            },
            onExamAttach(exam){
                var vm = this
                if(vm.eventDetails){

                    const foundIndex = vm.eventDetails
                            .physical_exams.findIndex(ex => ex.id === exam.id)

                    if(foundIndex !== -1){
                        vm.eventDetails.physical_exams.splice(foundIndex, 1, exam)
                    }else{
                        vm.eventDetails.physical_exams.push(exam)
                    }

                }
            },
            onOptionDetach(option){
                var vm = this

                if(vm.eventDetails){

                    const foundIndex = vm.eventDetails
                            .anamnesis
                            .anamnesis_options
                            .findIndex(item => item.id === option.id)

                    if(foundIndex !== -1){
                        vm.eventDetails
                                .anamnesis
                                .anamnesis_options
                                .splice(foundIndex, 1)
                    }
                }
            },
            onOptionAttach(option){
                var vm = this
                if(!vm.eventDetails) return

                if(vm.eventDetails){

                    const foundIndex = vm.eventDetails
                                    .anamnesis
                                    .anamnesis_options.findIndex(ex => ex.id === option.id) || null

                    if(foundIndex !== -1){
                        vm.eventDetails
                                .anamnesis
                                .anamnesis_options
                                .splice(foundIndex, 1, option)
                    }else{
                        vm.eventDetails
                                .anamnesis
                                .anamnesis_options
                                .push(option)
                    }

                }
            },
            onSymptomDetach(symptom){

                var vm = this

                if(vm.eventDetails){

                    const foundIndex = vm.eventDetails
                            .anamnesis
                            .symptoms
                            .findIndex(item => item.id === Number(symptom.id))

                    if(foundIndex !== -1){
                        vm.eventDetails
                                .anamnesis
                                .symptoms
                                .splice(foundIndex, 1)
                    }
                }
            },
            onCommentUpdate(comment){
                var vm = this
                if(!vm.eventDetails || !vm.eventDetails.anamnesis) return
                vm.eventDetails.anamnesis.comment = comment
            },
            onSymptomAttach(symptom){
                var vm = this

                if(vm.eventDetails){

                    const foundIndex = vm.eventDetails
                                    .anamnesis
                                    .symptoms.findIndex(ex => ex.id === symptom.id) || null

                    if(foundIndex !== -1){
                        vm.eventDetails
                                .anamnesis
                                .symptoms
                                .splice(foundIndex, 1, symptom)
                    }else{
                        vm.eventDetails
                                .anamnesis
                                .symptoms
                                .push(symptom)
                    }

                }
            }
        },
        computed: {
          getPhysicalExamName
        }
    }
</script>
